import React from "react"

import styles from "./features.module.css"

export default function Features({ children }) {
  return <div className={`row ${styles.features}`}>{children}</div>
}
